import { MOBILE_E164_PATTERN, normalizeCodeInput, normalizeMobileField } from '@saay/formatting';

/** Maps the unified buyer search box to `listAdminBuyers` query params (ADM-36). */
export type BuyerSearchQuery = {
  readonly mobileE164?: string;
  readonly nationalCode?: string;
  readonly q?: string;
};

const SEARCH_MIN_NAME = 3;

export function buyerSearchFromText(
  raw: string,
): { readonly filters: BuyerSearchQuery } | { readonly message: string } {
  const trimmed = raw.trim();
  if (trimmed === '') {
    return { filters: {} };
  }
  const digits = normalizeCodeInput(trimmed).replace(/\D/g, '');
  const nonIdentifierChars = trimmed.replace(/[0-9۰-۹٠-٩\s\u200c./-]/g, '');
  const looksLikeIdentifier = digits.length > 0 && nonIdentifierChars.length === 0;
  if (!looksLikeIdentifier && /[A-Za-z\u0600-\u06FF]/.test(trimmed)) {
    if (trimmed.length < SEARCH_MIN_NAME) {
      return { message: 'برای جست‌وجو دست‌کم ۳ حرف وارد کنید.' };
    }
    return { filters: { q: trimmed } };
  }
  if (digits.length > 0) {
    if (/^09\d{9}$/.test(digits)) {
      const mobileE164 = normalizeMobileField(digits);
      if (!MOBILE_E164_PATTERN.test(mobileE164)) {
        return { message: 'شماره موبایل معتبر نیست.' };
      }
      return { filters: { mobileE164 } };
    }
    if (/^\d{10}$/.test(digits)) {
      return { filters: { nationalCode: digits } };
    }
    return { message: 'برای موبایل ۱۱ رقم با ۰۹ یا کد ملی ۱۰ رقم وارد کنید.' };
  }
  return { message: 'برای جست‌وجو دست‌کم ۳ حرف وارد کنید.' };
}
